document.addEventListener('DOMContentLoaded', function() {
	/**
	 * Simple Lightbox for Single Product Gallery
	 *
	 * This module provides a lightweight, vanilla JavaScript lightbox functionality
	 * for the main images in the WooCommerce single product gallery. It allows
	 * users to view a larger version of the product image in a modal overlay.
	 */
	const lightbox = document.getElementById('product-lightbox');
	if (lightbox) {
		const lightboxImage = lightbox.querySelector('img');
		const lightboxClose = lightbox.querySelector('.lightbox-close');
		const mainGallerySlides = document.querySelectorAll('.product-gallery-main .swiper-slide img');

		/**
		 * Attaches click event listeners to the main gallery images.
		 * When an image is clicked, it opens the lightbox with the corresponding
		 * large image.
		 * @param {Event} e The click event object.
		 */
		mainGallerySlides.forEach(slideImage => {
			slideImage.style.cursor = 'pointer';
			slideImage.addEventListener('click', (e) => {
				e.preventDefault();
				const largeImageUrl = slideImage.getAttribute('data-large_image');
				if (largeImageUrl) {
					lightboxImage.setAttribute('src', largeImageUrl);
					lightbox.classList.add('active');
				}
			});
		});

		/**
		 * Closes the lightbox modal.
		 * It removes the 'active' class to hide the overlay and clears the
		 * image source to prevent it from being visible during the closing transition.
		 */
		const closeLightbox = () => {
			lightbox.classList.remove('active');
			lightboxImage.setAttribute('src', '');
		}

		lightboxClose.addEventListener('click', closeLightbox);

		/**
		 * Adds a click event listener to the lightbox overlay.
		 * This allows the user to close the lightbox by clicking on the
		 * background area outside of the image content.
		 * @param {Event} e The click event object.
		 */
		lightbox.addEventListener('click', (e) => {
			if (e.target === lightbox) {
				closeLightbox();
			}
		});

		/**
		 * Adds a keydown event listener to the document.
		 * This allows the user to close the lightbox by pressing the 'Escape' key.
		 * @param {Event} e The keydown event object.
		 */
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && lightbox.classList.contains('active')) {
				closeLightbox();
			}
		});
	}
});
